/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} HourInputs */

const en_hour = /** @type {(inputs: HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hour`)
};

const ar_hour = /** @type {(inputs: HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ساعة`)
};

const de_hour = /** @type {(inputs: HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stunde`)
};

const es_hour = /** @type {(inputs: HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hora`)
};

const fr_hour = /** @type {(inputs: HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`heure`)
};

const it_hour = /** @type {(inputs: HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ora`)
};

const ja_hour = /** @type {(inputs: HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時間`)
};

const ko_hour = /** @type {(inputs: HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시간`)
};

const pt_br_hour = /** @type {(inputs: HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hora`)
};

const ru_hour = /** @type {(inputs: HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`час(а)`)
};

const th_hour = /** @type {(inputs: HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชั่วโมง`)
};

const tr_hour = /** @type {(inputs: HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`saat`)
};

const zh_cn_hour = /** @type {(inputs: HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小时`)
};

const zh_tw_hour = /** @type {(inputs: HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小時`)
};

/**
* | output |
* | --- |
* | "hour" |
*
* @param {HourInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const hour = /** @type {((inputs?: HourInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<HourInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hour(inputs)
	if (locale === "ar") return ar_hour(inputs)
	if (locale === "de") return de_hour(inputs)
	if (locale === "es") return es_hour(inputs)
	if (locale === "fr") return fr_hour(inputs)
	if (locale === "it") return it_hour(inputs)
	if (locale === "ja") return ja_hour(inputs)
	if (locale === "ko") return ko_hour(inputs)
	if (locale === "pt_br") return pt_br_hour(inputs)
	if (locale === "ru") return ru_hour(inputs)
	if (locale === "th") return th_hour(inputs)
	if (locale === "tr") return tr_hour(inputs)
	if (locale === "zh_cn") return zh_cn_hour(inputs)
	return zh_tw_hour(inputs)
});